export const assigneeField = 'ai-copy-link-assignee-field';
export const confidenceField = 'ai-copy-link-confidence-field';
export const createNewField = 'ai-copy-link-create-new-field';
export const dueDateField = 'ai-copy-link-due-date-field';
export const effortField = 'ai-copy-link-effort-field';
export const form = 'ai-copy-link-form';
export const fromDateField = 'ai-copy-link-from-date-field';
export const nameField = 'ai-copy-link-name-field';
export const priorityField = 'ai-copy-link-priority-field';
export const relationshipTypeField = 'ai-copy-link-relationship-type-field';
export const statusField = 'ai-copy-link-status-field';
export const workstreamField = 'ai-copy-link-workstream-field';
export const cancelBtn = 'ai-copy-link-cancel-btn';
export const submitBtn = 'ai-copy-link-submit-btn';
